import { DataService } from './data.service';
import { Injectable, OnDestroy } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { environment } from '../../environment/environment';
import { ConfigStatus } from '../constants/constants';

@Injectable({
  providedIn: 'root'
})
export class LockService implements OnDestroy {
  private isLocked = new BehaviorSubject<boolean>(false);
  isLocked$ = this.isLocked.asObservable();
  private autoLockTimer: any;
  config: ConfigStatus;

  constructor(private dataService: DataService) {
    let initialLoad = true;
    this.dataService.configStatus.subscribe(config=>{
      this.config = config;
      if (initialLoad && this.config?.screenPin){
        initialLoad = false;
        this.lock();
      }
    })
  }

  lock() {
    if(this.config?.screenPin){
      this.isLocked.next(true);
      this.clearAutoLockTimer();
    }
  }

  unlock(enteredPin: string): boolean {
    if (enteredPin === this.config?.screenPin) {
      this.isLocked.next(false);
      if (environment.isController) {
        this.startAutoLockTimer();
      }
      return true;
    }
    return false;
  }

  getLockState(): boolean {
    return this.isLocked.value;
  }

  startAutoLockTimer() {
    if (!environment.isController) return;

    this.clearAutoLockTimer();
    if(this.config?.screenTimeout){
      this.autoLockTimer = setTimeout(() => {
        this.lock();
      }, this.config?.screenTimeout*1000);
    }

  }

  resetAutoLockTimer() {
    if (!environment.isController) return;

    this.clearAutoLockTimer();
    this.startAutoLockTimer();
  }

  private clearAutoLockTimer() {
    if (this.autoLockTimer) {
      clearTimeout(this.autoLockTimer);
      this.autoLockTimer = null;
    }
  }

  ngOnDestroy() {
    this.clearAutoLockTimer();
  }
}
